var config = {
    api_url: "api.editor.john-steel.com:3030",
    editor_url: "editor.john-steel.com:443"
};
module.exports = config;
